$(function() {
  $('html').toggleClass('is-safari', navigator.userAgent.toLowerCase().indexOf('safari') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0);
});



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/serp_item.js
// module id = 501
// module chunks = 0